<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      finish-button-text="Ajouter"
      back-button-text="Précédant"
      next-button-text="suivant"
      class="wizard-vertical mb-3"
      @on-complete="addProduct"
    >
      <!-- account datails tab -->
      <tab-content title="Produit">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Produit</h5>
            <small class="text-muted">
              Information général sur le produit.
            </small>
          </b-col>
          <b-col md="6">
            <b-form-group label="Code" label-for="v-code">
              <b-form-input
                id="v-code"
                placeholder="000001"
                v-model="product.code"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Label" label-for="v-label">
              <b-form-input
                id="v-label"
                placeholder="Nom du produit"
                v-model="product.label"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Marque" label-for="v-marque">
              <b-form-input
                id="v-marque"
                placeholder="Marque"
                v-model="product.brand"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Magasin" label-for="v-magasin">
              <b-form-input
                id="v-magasin"
                placeholder="Magasin"
                v-model="product.storeShelf"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Déscription" label-for="v-description">
              <b-form-textarea
                id="v-description"
                placeholder="Ce produit est ..."
                rows="3"
                v-model="product.description"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- personal info tab -->
      <tab-content title="Détail produit">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Détail produit</h5>
            <small class="text-muted">Détail du produit ...</small>
          </b-col>
          <b-col md="6">
            <b-form-group label="Quantité" label-for="v-quantity">
              <b-form-input
                id="v-quantity"
                placeholder="5"
                v-model="product.quantity"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Poids" label-for="v-poids">
              <b-input-group append="g">
                <b-form-input
                  id="v-poids"
                  placeholder="20"
                  v-model="product.weight"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Catégorie" label-for="v-cat">
              <v-select
                id="v-cat"
                v-model="product.categories"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                multiple
                label="title"
                :options="optionCategorie"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="v-souCat" label="Sous catégorie">
              <v-select
                id="v-souCat"
                v-model="product.subCategories"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                multiple
                label="title"
                :options="optionSubCategorie"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- address -->
      <tab-content title="Prix du produit">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Prix du produit ({{externalUserCurrency()}})</h5>
            <small class="text-muted">Prix, tax et remise du produit.</small>
          </b-col>
          <b-col md="6">
            <b-form-group label="Prix hors tax" label-for="v-pth">
              <b-input-group append="$">
                <b-form-input
                  id="v-pth"
                  placeholder="1000"
                  v-model="product.priceWithoutTaxes"
                  @input="totalePriceProduct()"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Tax" label-for="v-tax">
              <b-input-group append="%">
                <b-form-input
                  id="v-tax"
                  placeholder="10"
                  v-model="product.valueAddedTax"
                  @input="percentageValue(product),totalePriceProduct()"
                  @change="percentageValue(product)"
                />
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Remise" label-for="v-remise">
              <b-input-group append="%">
                <b-form-input
                  id="v-remise"
                  placeholder="10"
                  v-model="product.discount"
                  @input="percentageValue(product),totalePriceProduct()"
                  @change="percentageValue(product)"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Margin" label-for="v-margin">
              <b-input-group append="%">
                <b-form-input
                  id="v-margin"
                  placeholder="10"
                  v-model="product.margin"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Prix total" label-for="v-ptt">
              <b-input-group append="$">
                <b-form-input
                  id="v-ptt"
                  placeholder="1100"
                  v-model="product.totalPrice"
                  disabled
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Prix total avec remise" label-for="v-ptt">
              <b-input-group append="$">
                <b-form-input
                  id="v-ptt"
                  placeholder="1100"
                  disabled
                  v-model="totalPriceDiscount"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- social link -->
      <tab-content title="Image du produit">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Image produit</h5>
            <small class="text-muted">Image et code à barre</small>
          </b-col>
          <b-col md="6">
            <b-form-group label="Code à barre" label-for="v-cab">
              <b-form-input id="disabledInput" disabled />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Image du produit" label-for="v-image">
              <!-- <b-form-file
                id="v-image"
                accept="image/*"
                v-model="product.image"
              /> -->
              <b-form-input
                id="v-image"
                v-model="product.image"
                readonly
                placeholder="Cliquer ici pour ajouter une image"
                @click="openUploadModal()"
              />
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="product.code != null">
            <barcode
              :value="barCodeValue()"
              :options="{ lineColor: '#0275d8', text: 'Scan' }"
            ></barcode>
          </b-col>
          <b-col md="6" v-if="product.image != ''">
            <b-img :src="imgProduct()" fluid alt="Responsive image" />
          </b-col>
        </b-row>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import VueBarcode from "vue-barcode";
import axios from "axios";
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BImg,
  BRow,
  BCol,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormGroup,
  BFormFile,
  BFormInput,
  BFormTextarea,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { GetLinkCurrency } from "@/utils/utils.js";

export default {
  components: {
    VueBarcode,
    BImg,
    BFormFile,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormTextarea,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      optionCategorie: [],
      optionSubCategorie: [],
      categories: [],
      subCategories: [],
      totalPriceDiscount: 0,
      product: {
        createdBy: JSON.parse(localStorage.getItem("userData"))._id,
        code: null,
        label: "",
        brand: "",
        quantity: "",
        priceWithoutTaxes: 0,
        valueAddedTax: 0,
        totalPrice: 0,
        weight: "",
        description: "",
        discount: 0,
        margin: 0,
        storeShelf: "",
        barCode: "",
        image: "",
        createdBy: JSON.parse(localStorage.getItem("userData"))._id,
        categories: [],
        subCategories: [],
      },
    };
  },
  created() {
    //get all category + subcategory
    axios
      .get("https://management-projects.herokuapp.com/api/categories")
      .then((response) => {
        console.log("get all category", response);
        this.categories = response.data;
        response.data.forEach((element) => {
          // this.subCategories.push(element.subCategories);
          this.optionCategorie.push({ title: element.label, id: element._id });
          element.subCategories.forEach((subElement) => {
            this.optionSubCategorie.push({
              title: subElement.label,
              id: subElement._id,
            });
          });
        });
      })
      .catch((error) => {
        this.errorMessage = error.message;
      });
  },
  methods: {
    // get currency
    externalUserCurrency() {
      return GetLinkCurrency();
    },

    openUploadModal() {
      window.cloudinary
        .openUploadWidget(
          { cloud_name: "dmdd546ps", upload_preset: "jhyzlocs" },
          (error, result) => {
            if (!error && result && result.event === "success") {
              console.log("Done uploading..: ", result);
              this.url = result.info.url;
              this.publicId = result.info.public_id;
              this.product.image = this.publicId;
            }
          }
        )
        .open();
    },
    imgProduct() {
      return (
        "https://res.cloudinary.com/dmdd546ps/image/upload/v1615691410/" +
        this.product.image
      );
    },
    barCodeValue() {
      return this.product.code;
    },

    // totale price
    percentageValue(percentage){
      if(percentage.valueAddedTax<0) percentage.valueAddedTax = 0
      else if (percentage.valueAddedTax>100) percentage.valueAddedTax = 100

       if(percentage.discount<0) percentage.discount = 0
      else if (percentage.discount>100) percentage.discount = 100
    },

    getPercentage(num, per)  {
      if (num != 0 && per != 0)
        return ((Number.parseFloat(num) / 100) * Number.parseFloat(per));
    },
    totalePriceProduct() {
      var taxValue=0
      var discountValue=0
      if(this.product.priceWithoutTaxes&&this.product.priceWithoutTaxes != 0){
        if(this.product.valueAddedTax  && this.product.valueAddedTax != 0){
              taxValue = this.getPercentage(this.product.priceWithoutTaxes,this.product.valueAddedTax)
        }
        this.product.totalPrice =Number.parseFloat(this.product.priceWithoutTaxes) +Number.parseFloat(taxValue) 
        if(this.product.discount != 0 && this.product.discount){
          discountValue = this.getPercentage(this.product.totalPrice,this.product.discount)
        }
        this.totalPriceDiscount =Number.parseFloat(this.product.totalPrice) -Number.parseFloat(discountValue) 
     }
    }, 


    addProduct() {
      var newCategories = this.product.categories.map((element) => {
        return element.id;
      });
      this.product.categories = newCategories;
      var newSubCategories = this.product.subCategories.map((element) => {
        return element.id;
      });
      this.product.subCategories = newSubCategories;
      console.log("product", this.product);
      axios
        .post(
          "https://management-projects.herokuapp.com/api/products",
          this.product
        )
        .then((response) => {
          console.log(response);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Produit bien ajouté",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.$router.replace("/stock");
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erreur lors de l'ajout du produit",
              icon: "EditIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
